import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective {

  private specialKeys = [
    'Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'Home',
    'End', 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste'
  ];

  inputElement: HTMLElement;

  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {

    if (
      this.specialKeys.indexOf(e.key) > -1 ||
      (e.key === 'a' && e.ctrlKey === true) ||
      (e.key === 'c' && e.ctrlKey === true) ||
      (e.key === 'v' && e.ctrlKey === true) ||
      (e.key === 'x' && e.ctrlKey === true) ||
      (e.key === 'a' && e.metaKey === true) ||
      (e.key === 'c' && e.metaKey === true) ||
      (e.key === 'v' && e.metaKey === true) ||
      (e.key === 'x' && e.metaKey === true)
    ) {
      return;
    }
    // if (e.shiftKey || (parseInt(e.key) < 0 && parseInt(e.key) >9 )) {
    //   e.preventDefault();
    // }
    var aceito : boolean;
     switch (e.key) {
      // case '.':
      // case '-':
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        aceito=true;
        break;
      default:
        aceito=false;
    }
    if(!aceito) e.preventDefault();
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(e: KeyboardEvent) {

    var aceito : boolean;
     switch (e.key) {
      // case '.':
      // case '-':
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        aceito=true;
        break;
      default:
        aceito=false;
    }
    if(!aceito) e.preventDefault();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {

    event.preventDefault();
    if(event.clipboardData != null){
      event.preventDefault();
      const pastedInput: string = event.clipboardData
        .getData('text/plain')
        .replace(/\D/g,'');
      document.execCommand('insertText', false, pastedInput);
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {

    event.preventDefault();
    if(event.dataTransfer != null){
    const textData = event.dataTransfer.getData('text').replace(/\D/g,'');
    this.inputElement.focus();
    document.execCommand('insertText', false, textData);
    }
  }

}
